export default "/_next/static/assets/images/logo-sporttip_bet.be7b92d1ac159f4b2187076e4c9fb48e.png";